export class RetailerSearch {
  constructor(linkBusinessMdlService, config) {
    this.linkBusinessMdlService = linkBusinessMdlService;
    this.config = config;
    this.el = config.el;
    this.content = config.content;
    this.hasRetailers = false;
    this.retailerGrid = document.getElementById(this.el.retailerGrid);
    this.provinceFld = document.getElementById(this.el.provinceFld);
    this.provinceFld.onchange = async (event) => {
      await this.displayRetailersByProvince(this.provinceFld.value);
    }
    this.postalCodeFld = document.getElementById(this.el.postalCodeFld);
    this.maxDistanceFld = document.getElementById(this.el.maxDistanceFld);
    this.postalCodeFld.addEventListener('keydown', async event => {
      if (event.key === 'Enter') {
        await this.displayRetailersByPostalCode(this.postalCodeFld.value, this.maxDistanceFld.value);
      }
    });
    this.postalCodeFld.addEventListener('input', event => {
      this.toggleSearchBtnEnabled();
    });
    this.maxDistanceFld.onchange = async (event) => {
      await this.displayRetailersByPostalCode(this.postalCodeFld.value, this.maxDistanceFld.value);
      this.toggleSearchBtnEnabled();
    }
    this.searchBtn = document.getElementById(this.el.searchBtn);
    this.searchBtn.addEventListener('click', async event => {
      await this.displayRetailersByPostalCode(this.postalCodeFld.value, this.maxDistanceFld.value);
    });
    this.toggleSearchBtnEnabled();
    this.retailerMapElement = document.getElementById(this.el.mapId);
    this.toggleMapBtn = document.getElementById(this.el.toggleMapBtn);
    this.toggleMapBtn.addEventListener('click', event => this.toggleIsMapVisible());
    this.noRetailersFoundMsg = document.getElementById(this.el.noRetailersFoundMsg);
  }

  /** This method should be called when external mapping scripts have been loaded, e.g. the Google maps api. */
  notifyMapScriptLibraryLoaded() {
    if (this.isMapInitPending) {
      this.initMap();
    }
  }

  initMap() {
    this.centerOfNorway = { lat: 65, lng: 12 };
    this.norwayZoomLevel = 4;
    if (window.isMapScriptLibraryLoaded) {
      this.isMapInitPending = false;
      this.map = new google.maps.Map(this.retailerMapElement, { center: this.centerOfNorway, zoom: this.norwayZoomLevel, });
    } else {
      this.isMapInitPending = true;
    }
  }

  toggleIsMapVisible(isVisible) {
    if (typeof isVisible !== 'undefined') {
      this.isMapVisible = isVisible;
    } else {
      this.isMapVisible = !this.isMapVisible;
    }
    this.toggleMapBtn.value = this.isMapVisible ? this.content.hideMapLabel : this.content.showMapLabel;
    this.retailerMapElement.classList.toggle('d-none', !this.isMapVisible);
    if (this.isMapVisible) {
      if (!this.map) {
        this.initMap();
      }
      this.displayRetailersOnMap();
    }
  }

  toggleSearchBtnEnabled() {
    this.searchBtn.disabled = !(this.postalCodeFld.value && this.maxDistanceFld.value);
  }

  addRetailerAddressAnchorTag(retailer, caption) {
    const query = encodeURIComponent(`${retailer.name} ${retailer.storeAddress.city}`);
    const url = `https://maps.google.com/maps?q=${query}`;
    return `<a class="addr-map-link" href="${url}" target="_blank">${caption}</a>`;
  }

  setMarkerSymbol(marker, strokeColor, fillColor, strokeWeight) {
    const symbol = {
      path: google.maps.SymbolPath.CIRCLE,
      scale: 8,
      fillColor: fillColor,
      fillOpacity: 1,
      strokeColor: strokeColor,
      strokeWeight: strokeWeight
    };
    marker.setIcon(symbol);
  }

  setSelectedMarkerSymbol(marker) {
    this.setMarkerSymbol(marker, 'orange', 'red', 4);
  }

  setUnselectedMarkerSymbol(marker) {
    this.setMarkerSymbol(marker, 'darkred', 'red', 4);
  }

  getGridItemByIndex(index) {
    const items = this.retailerGrid.querySelectorAll('.' + this.el.retailerGridItem);
    return items[index];
  }

  unselectMapMarker(marker) {
    this.setUnselectedMarkerSymbol(marker);
    if (marker.infoWindow) {
      marker.infoWindow.close();
      marker.infoWindow = null;
    }
    const gridItem = this.getGridItemByIndex(marker.retailerIndex);
    if (gridItem && gridItem.classList) {// Got error report: "undefined is not an object (evaluating 'this.getGridItemByIndex(t.retailerIndex).classList')"
      gridItem.classList.toggle('selected', false);
    }
  }

  selectMapMarker(marker) {
    if (this.selectedMarker) {
      this.unselectMapMarker(this.selectedMarker);
    }
    this.setSelectedMarkerSymbol(marker);
    this.selectedMarker = marker;
    const gridItem = this.getGridItemByIndex(marker.retailerIndex);
    gridItem.classList.toggle('selected', true);
    const showCardElemId = `show-card-${marker.retailerIndex}`;
    const infoWindow = new google.maps.InfoWindow({
      content: `${marker.title}<br/><a id='${showCardElemId}' href='#'>${this.content.showCardLabel}</>`
    });
    // Wait until the infoWindow has been added to the DOM, then attach a click handler to the anchor tag:
    google.maps.event.addListenerOnce(infoWindow, 'domready', () => {
      const showCardElem = document.getElementById(showCardElemId);
      showCardElem.addEventListener('click', async event => {
        event.preventDefault();
        // Scroll the card into view:
        jQuery(gridItem).velocity('scroll', {
          offset: 0,
          duration: 1200,
          easing: 'easeOutExpo',
          mobileHA: false,
          complete: elements => { },
        });
      });
    });
    infoWindow.open(this.map, marker);
    marker.infoWindow = infoWindow; // This is our "annotation", not a predefined property of the marker class.
  }

  addMapMarker(retailer, index) {
    const marker = new google.maps.Marker({
      position: { lat: retailer.storeAddress.latitude, lng: retailer.storeAddress.longitude },
      map: this.map,
      title: retailer.name,
    });
    marker.retailerIndex = index;
    this.mapMarkers.push(marker);

    marker.addListener("click", () => this.selectMapMarker(marker));
    return marker;
  }

  resetMapMarkers() {
    if (this.mapMarkers) {
      this.mapMarkers.forEach(marker => marker.setMap(null));
    }
    this.mapMarkers = [];
  }

  displayRetailersOnMap() {
    this.resetMapMarkers();
    if (this.retailers && this.retailers.length) {
      let bounds = new google.maps.LatLngBounds();
      this.retailers.forEach((retailer, index) => {
        const marker = this.addMapMarker(retailer, index);
        bounds.extend(marker.getPosition());
        this.setUnselectedMarkerSymbol(marker);
      });
      this.map.fitBounds(bounds);
    } else {
      this.map.setZoom(this.norwayZoomLevel);
      this.map.setCenter(this.centerOfNorway);
    }
  }

  async displayRetailers(retailers) {
    const retailerTemplate = document.getElementById(this.el.retailerTemplate);
    const addressLinkTemplate = document.getElementById(this.el.retailerAddressLink);

    // The grid listing the retailers uses the isotope library.See https://isotope.metafizzy.co/
    // and our own code inside unishop.js for more.
    // Note, the following code is jQuery dependent. It's also a copy of the code inside unishop.js:
    const $isotopeGrid = $('#' + this.el.retailerGrid);
    let isotope = $isotopeGrid.data('isotope');
    /* Ideally we shouldn't have to destroy and recreate the isotope grid, but for some unknown
     * reason, when we do that, the visual layout ends up animating twice. If/when we find out
     * how to fix that, we can set the useDestroyAndRecreate variable to false. 12/31/2023. */
    const useDestroyAndRecreate = true;
    if (!useDestroyAndRecreate) {
      // Clear existing retailers
      //isotope.remove(isotope.getItemElements()); // Remove the old items from isotope. Enable when we find out how to avoid double layout later
    }
    const elementsToRemove = this.retailerGrid.querySelectorAll('.' + this.el.retailerGridItem);
    elementsToRemove.forEach(element => element.remove());

    const br = '<br/>';
    const svgIconUseElement = `.${this.el.svgIcon} use`;
    const addresslinkAnchorClass = '.' + this.el.addressLinkAnchor;
    this.hasRetailers = false;
    this.retailers = retailers;
    // Populate and append a clone of the template for each retailer
    retailers.forEach((retailer, index) => {
      this.hasRetailers = true;
      const addr = retailer.storeAddress;
      const clone = retailerTemplate.content.cloneNode(/*deep:*/ true);

      let addressHtml = ``;
      if (addr.address1) {
        addressHtml += addr.address1 + br;
      };
      if (addr.address2) {
        addressHtml += addr.address2 + br;
      };
      addressHtml += addr.postalCode + ' ' + addr.city + this.addRetailerAddressAnchorTag(retailer, this.content.showExternalMapLabel) + br;

      let headerHtml = `<span class="retailer-name">${retailer.name}</span>`;
      if (retailer.isInCampaign) {
        headerHtml += `<br /><span class="retailer-campaign">${retailer.campaignFlag}</span>`;
      }
      const header = clone.querySelector(this.el.retailerHeaderSelector);
      header.innerHTML = headerHtml;
      header.onclick = () => {
        if (!this.isMapVisible) {
          this.toggleIsMapVisible();
        }
        this.selectMapMarker(this.mapMarkers[index]);
        if (this.isMapVisible) {
          // Scroll the map into view:
          jQuery(this.retailerMapElement).velocity('scroll', {
            offset: 0,
            duration: 1200,
            easing: 'easeOutExpo',
            mobileHA: false,
            complete: elements => { },
          });
        }
      };

      const addressElement = clone.querySelector(this.el.retailerAddressSelector);
      addressElement.innerHTML = addressHtml;

      if (retailer.phone1) {
        const linkClone = addressLinkTemplate.content.cloneNode(/*deep:*/ true);
        linkClone.querySelector(svgIconUseElement).setAttribute('xlink:href', '#icon-phone');
        const anchor = linkClone.querySelector(addresslinkAnchorClass);
        anchor.setAttribute('href', 'tel:' + retailer.phone1);
        anchor.textContent = retailer.phone1;
        addressElement.appendChild(linkClone);
      }

      if (retailer.webSiteUrl) {
        const linkClone = addressLinkTemplate.content.cloneNode(/*deep:*/ true);
        linkClone.querySelector(svgIconUseElement).setAttribute('xlink:href', '#icon-globe');
        const anchor = linkClone.querySelector(addresslinkAnchorClass);
        anchor.setAttribute('href', retailer.webSiteUrl);
        anchor.textContent = retailer.webSiteUrl;
        addressElement.appendChild(linkClone);
      }

      this.retailerGrid.appendChild(clone);
    });

    if (useDestroyAndRecreate) {
      isotope.destroy();
      // This is a copy of the code in unishop. We probably want to keep them in sync:
      isotope = $isotopeGrid.isotope({
        itemSelector: '.grid-item',
        transitionDuration: '0.7s',
        masonry: {
          columnWidth: '.grid-sizer',
          gutter: '.gutter-sizer'
        }
      });
    } else {
      const newItems = $isotopeGrid.find('.grid-item');
      isotope.appended(newItems); // Let Isotope know about the new items
      isotope.layout();
    }
    if (this.isMapVisible) {
      this.displayRetailersOnMap();
    }
    this.noRetailersFoundMsg.classList.toggle('d-none', this.hasRetailers);
  }

  async displayRetailersByProvince(province) {
    const retailers = await this.linkBusinessMdlService.getRetailers('Region', province);
    this.postalCodeFld.value = '';
    this.toggleSearchBtnEnabled();
    this.displayRetailers(retailers);
  }

  async displayRetailersByPostalCode(postalCode, maxDistance) {
    const retailers = await this.linkBusinessMdlService.getRetailers('PostalCode', postalCode, maxDistance);
    this.provinceFld.selectedIndex = 0;
    this.displayRetailers(retailers);
  }
}
